
import React, { Suspense, useEffect, useState } from "react";
import { BaseUrl } from '../../helper/BaseUrl';
import { fetchJson } from '../../helper/fetchJson';
import useViewportActivation from '../../hooks/useViewportActivation';

const Slider = React.lazy(() => import("react-slick"));

export default function HomeLogos() {
  const [data, setData] = useState([]);
  const [sectionRef, isNearViewport] = useViewportActivation();
  useEffect(() => {
    let active = true;
    let idleId;
    let timerId;

    const fetchLogos = async () => {
      try {
        const result = await fetchJson(`${BaseUrl}/api/logos`);
        if (active) setData(result.logos);
      } catch (error) {
        console.error('Fetch error:', error.message);
      }
    };

    const scheduleFetch = () => {
      if ("requestIdleCallback" in window) {
        idleId = window.requestIdleCallback(fetchLogos, { timeout: 2500 });
      } else {
        timerId = window.setTimeout(fetchLogos, 1200);
      }
    };

    if (document.readyState === "complete") scheduleFetch();
    else window.addEventListener("load", scheduleFetch, { once: true });

    return () => {
      active = false;
      window.removeEventListener("load", scheduleFetch);
      if (idleId) window.cancelIdleCallback(idleId);
      if (timerId) window.clearTimeout(timerId);
    };
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 8000,
    cssEase: 'linear',
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: { slidesToShow: 4 }
      },
      {
        breakpoint: 767,
        settings: { slidesToShow: 3 }
      },
      {
        breakpoint: 599,
        settings: { slidesToShow: 2 }
      }
    ]
  };

  return (
    <section ref={sectionRef} className="home-partner space">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-12">
            <div className="partner-text heading-gap">
              <h4 className="heading heading-center ">
                600+ leading brands Trusts Us
              </h4>
            </div>
          </div>
        </div>
        <div className="home-brand-slider">
          {data.length > 0 && isNearViewport && (
            <Suspense fallback={null}>
              <Slider {...settings}>
                {data.map((logo, index) => (
                  <div className="homepartner-box" key={index}>
                    <div className="partner-inner">
                      <img src={BaseUrl + logo?.logo} alt={logo?.alt_logo} className="img-fluid" loading="lazy" />
                    </div>
                  </div>
                ))}
              </Slider>
            </Suspense>
          )}
        </div>
      </div>
    </section>
  );
}
